<template>
	<a-modal :title="form.title" :visible="visible" centered :destroy-on-close="true" :mask-closable="false"
		:confirm-loading="confirmLoading" :footer="null" @ok="onSubmit" @cancel="onClose">
		<div class="content">
			<p style="font-size: 16px;margin-bottom: 20px;" v-html="form.content"></p>
			<!-- <p style="color: #1890ff;">请到相关菜单查看具体信息</p> -->
		</div>
	</a-modal>
</template>
<script>
import { formMixin } from "@/mixins";

export default {
	name: "DetailModal",
	components: {},

	mixins: [formMixin],
	data() {
		return {
			form: {
				parentId: null,
			},
		}
	},
}
</script>
<style scoped lang="less">
.content {
	min-height: 120px;
}
</style>
